export const UPDATE_CONTRIBUTION = "NewCostBreakDown/UPDATE_CONTRIBUTION";
export function updateContribution(field, value) {
  return {
    type: UPDATE_CONTRIBUTION,
    payload: {
      field,
      value,
    },
    meta: {
      analytics: {
        type: "contribution_updated",
        properties: {
          type: field,
          value,
          deprecatedName: `updated-contribution/${field}`,
          deprecatedLabel: null,
          deprecatedValue: value,
        },
      },
    },
  };
}
